<template>

<div>
    <form class="tags-dialog control-container token-editor">
<h3>Modify</h3>
<b-field label="">
 <b-input
    type="edit"
    :value="edit"
    placeholder=""
    @input="onInputChanged"
    @blur="onBlurred"
    >
    </b-input>
</b-field>

</form>
</div>
</template>


<script>
 export default {
        props: ['edit','index'],
        methods:{
            onInputChanged (newValue){
                this.$emit('popupChange',newValue, this.index)
            },
            onBlurred (value){
                this.$emit('popupBlur',value, this.index)
            }
        }
    }

</script>

<style>

</style>